import React, { useState } from 'react';
import { useParams } from 'react-router';
import { AnalyticsEventSource } from '@atlassian/temp-analytics';
import { OffSessionPaymentMethodConfirm } from '@atlassian/commerce-ui/payment-flow';
import { InfoPanel } from '@css-xp/base';
import './confirm-payment-page.scss';
import { ScreenEventAnalytics } from '@css-xp/ppc-common';

export const ConfirmPaymentPage = () => {
  const { txaId, invoiceId } = useParams<{ txaId: string; invoiceId: string }>();
  const [confirmationDisplayed, setConfirmationDisplayed] = useState(false);

  if (confirmationDisplayed) {
    return (
      <div className="ppc-confirm-payment-page-success-infopanel">
        <InfoPanel
          type="success"
          title="We've confirmed your payment method"
          message="You'll get an email once your payment has been processed - typically
    within 24 hours."
        />
      </div>
    );
  }
  return (
    <div className="ppc-confirm-payment-page">
      <ScreenEventAnalytics
        event={{
          name: AnalyticsEventSource.PARTNER_CONFIRM_PAYMENT_SCREEN,
          attributes: {},
        }}
      />
      <OffSessionPaymentMethodConfirm
        txa={txaId}
        invoiceId={invoiceId}
        onSuccess={() => setConfirmationDisplayed(true)}
      />
    </div>
  );
};
